import React, { useEffect } from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import ReactPDF, { PDFDownloadLink, PDFViewer, PDFRenderer } from '@react-pdf/renderer/dist/react-pdf.es';
import Button from '../../components/button/Button';
import { formatNumber, formatDateMin } from '../../misc/index';


const Nota = (props) => {

    const { nota } = props;

    return(
        <Document>
            <Page size="LETTER" style={styles.pagina}>
                <View style={styles.header}>
                    <Text style={styles.title}>{nota.empresa.razonSocial}</Text>
                    <Text style={styles.subTitle}>Nota contable</Text>
                </View>
                <View style={styles.proveedorContainer}>
                    <Text>N.I.T.: { nota.proveedor.nit }</Text>
                    <Text>PROVEEDOR: { nota.proveedor.razonSocial }</Text>
                </View>
                <View style={styles.bodyContainer}>
                    <View style={styles.encabezadoContainer}>
                        <View style={styles.campoContainer}>
                            <Text style={styles.campoTitulo}>Centro de operación: </Text>
                            <Text>{ nota.encabezado.idCo }</Text>
                        </View>
                        <View style={styles.campoContainer}>
                            <Text style={styles.campoTitulo}>Documento: </Text>
                            <Text>{ nota.encabezado.tipoDoc + "-" + nota.encabezado.numeroDoc }</Text>
                        </View>
                        <View style={styles.campoContainer}>
                            <Text style={styles.campoTitulo}>Fecha: </Text>
                            <Text>{ formatDateMin( new Date(nota.encabezado.fechaDoc) ) }</Text>
                        </View>
                        <View style={styles.campoContainer}>
                            <Text style={styles.campoTitulo}>Detalle: </Text>
                            <Text>{ nota.encabezado.notas }</Text>
                        </View>
                    </View>
                    <View style={styles.detalleContainer}>
                        <Text style={styles.subTitle2}>DETALLE:</Text>
                        <View style={styles.tabla}>
                            <View style={styles.th}>
                                <Text style={styles.tablaCampoTitulo}>C.O.</Text>
                                <Text style={styles.tablaCampoTitulo}>CUENTA</Text>
                                <Text style={styles.tablaCampoTitulo}>DETALLE</Text>
                                <Text style={styles.tablaCampoTitulo}>DEBITOS</Text>
                                <Text style={styles.tablaCampoTitulo}>CREDITOS</Text>
                            </View>
                            {
                                nota.detalles.detalles.map(
                                    detalle => {
                                        console.log(detalle);
                                        return(
                                            <View key={detalle.id} style={styles.tr}>
                                                <Text style={styles.tablaCampo}>{ detalle.idCo }</Text>
                                                <Text style={styles.tablaCampo}>{ detalle.cuentaId }</Text>
                                                <Text style={styles.tablaCampo}>{ detalle.cuentaDescripcion }</Text>
                                                <Text style={styles.tablaCampo}>${ formatNumber(detalle.valorDb) }</Text>
                                                <Text style={styles.tablaCampo}>${ formatNumber(detalle.valorCr) }</Text>
                                            </View>
                                        );
                                    }
                                )
                            }
                            <View style={styles.tr}>
                                <Text style={styles.tablaCampoTotal}>TOTAL:</Text>
                                <Text style={styles.tablaCampoTotal}></Text>
                                <Text style={styles.tablaCampo}></Text>
                                <Text style={styles.tablaCampo}>${ formatNumber(nota.encabezado.total_db) }</Text>
                                <Text style={styles.tablaCampo}>${ formatNumber(nota.encabezado.total_cr) }</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.detalleContainer, { marginTop: 20 }]}>
                        <Text style={styles.subTitle2}>DETALLE CONTABLE:</Text>
                        <View style={styles.tabla}>
                            <View style={styles.th}>
                                <Text style={[styles.tablaCampoTitulo, { width: 80 }]}>AUXILIAR</Text>
                                <Text style={[styles.tablaCampoTitulo, { width: 80 }]}>C.O.</Text>
                                <Text style={[styles.tablaCampoTitulo, { width: 80 }]}>U.N.</Text>
                                <Text style={[styles.tablaCampoTitulo, { width: 80 }]}>TERCERO</Text>
                                <Text style={[styles.tablaCampoTitulo, { width: 95 }]}>DEBITOS</Text>
                                <Text style={[styles.tablaCampoTitulo, { width: 95 }]}>CREDITOS</Text>
                            </View>
                            {
                                nota.detalleContable.map(
                                    detalle => {
                                        console.log(detalle);
                                        return(
                                            <View key={detalle.id} style={styles.tr}>
                                                <Text style={[styles.tablaCampo, { width: 80 }]}>{ detalle.cuentaId }</Text>
                                                <Text style={[styles.tablaCampo, { width: 80 }]}>{ detalle.idCoMov }</Text>
                                                <Text style={[styles.tablaCampo, { width: 80 }]}>{ detalle.idUN }</Text>
                                                <Text style={[styles.tablaCampo, { width: 80 }]}>{ detalle.nit }</Text>
                                                <Text style={[styles.tablaCampo, { width: 95 }]}>${ formatNumber(detalle.valorDb) }</Text>
                                                <Text style={[styles.tablaCampo, { width: 95 }]}>${ formatNumber(detalle.valorCr) }</Text>
                                            </View>
                                        );
                                    }
                                )
                            }
                        </View>
                    </View>
                </View>
                <View style={styles.pageNumber}>
                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
                </View>
            </Page>
        </Document>
    );
}

const NotaContablePDF = (props) => {

    useEffect(() => {

        if(!props.history.location.state.nota){
            props.history.push('/portal');
            return 0;
        }

    }, []);

    return(
        <>
            <div>
                <Button onClick={ () => { props.history.goBack() } } >Volver</Button>
            </div>
            <br />
            <PDFViewer style={{ width: '100%', height: '100vh' }}>
                <Nota nota={ props.history.location.state.nota } />
            </PDFViewer>
        </>
    );
}

const styles = StyleSheet.create({
    header: {
        alignItems: 'center',
        marginBottom: 50
    },
    title: {
        fontSize: 20,
        marginBottom: 10    
    },
    subTitle: {
        fontSize: 20,    
    },
    subTitle2: {
        fontSize: 10,
    },
    proveedorContainer: {
        fontSize: 10,
        marginBottom: 10
    },
    bodyContainer: {
        
    },
    encabezadoContainer: {
        fontSize: 10,
        marginBottom: 10
    },
    campoContainer: {
        flexDirection: 'row',
    },
    campoTitulo: {
        
    },
    tabla: {
        borderWidth: 1,
        borderRadius: 5,
        fontSize: 10
    },
    th: {
        flexDirection: 'row',
    },
    tr: {
        flexDirection: 'row',
    },
    tablaCampoTitulo: {
        backgroundColor: 'black',
        color: 'white',
        width: 102,
        borderRightWidth: 1,
        borderRightColor: 'white',
        paddingLeft: 5
        
    },
    tablaCampo: {
        width: 102,
        color: 'black',
        borderRightWidth: 1,
        borderRightColor: 'black',
        paddingLeft: 5,
        borderBottomWidth: 1
    },
    tablaCampoTotal: {
        width: 102,
        color: 'black',
        paddingLeft: 5,
        borderBottomWidth: 1
    },
    pagina: {
        padding: 50
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },
    retencionesContainer: {
        marginBottom: 10 
    }
});

export default NotaContablePDF;